import React, { Component } from 'react'

class MasterSvg extends Component {
    render() {
        return (
            <div style={{ width: 0, height: 0 }}>
                <svg id="master-svg" viewBox="100 100 110 110">
                    <defs>
                        <linearGradient
                            id="bg-semafor-red"
                            x1={93.89}
                            y1={17.38}
                            x2={16.11}
                            y2={95.17}
                            gradientTransform="matrix(1 0 0 -1 0 111.28)"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset={0} stopColor="#c31003" />
                            <stop offset={1} stopColor="#f3444a" />
                        </linearGradient>
                        <linearGradient
                            id="bg-semafor-red-shadow"
                            x1={32.45}
                            y1={42.7}
                            x2={77.55}
                            y2={68.74}
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset={0.3} stopColor="#fff" />
                            <stop offset={1} />
                        </linearGradient>
                        <linearGradient
                            id="bg-semafor-green"
                            x1={93.89}
                            y1={93.89}
                            x2={16.11}
                            y2={16.11}
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset={0} stopColor="#00c59e" />
                            <stop offset={1} stopColor="#9fd300" />
                        </linearGradient>
                        <linearGradient
                            id="bg-semafor-green-shadow"
                            x1={38.72}
                            y1={39.63}
                            x2={71.28}
                            y2={72.19}
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset={0} stopColor="#fff" stopOpacity={0} />
                            <stop offset={1} stopColor="#142200" />
                        </linearGradient>
                        <linearGradient
                            id="bg-semafor-yellow"
                            x1={93.89}
                            y1={93.89}
                            x2={16.11}
                            y2={16.11}
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset={0} stopColor="#ff4e00" />
                            <stop offset={1} stopColor="#ffd200" />
                        </linearGradient>
                        <linearGradient
                            id="bg-semafor-yellow-shadow"
                            x1={45.88}
                            y1={46.9}
                            x2={64.09}
                            y2={65.11}
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset={0} stopColor="#fff" stopOpacity={0} />
                            <stop offset={1} stopColor="#221a00" />
                        </linearGradient>
                        <linearGradient
                            id="semafor-green-aml-shadow"
                            x1={43.94}
                            y1={37.3}
                            x2={66.94}
                            y2={60.31}
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset={0} stopColor="#fff" />
                            <stop offset={0.3} stopColor="#f9f9f9" />
                            <stop offset={1} />
                        </linearGradient>
                        <linearGradient
                            id="semafor-red-aml-shadow"
                            x1={32.45}
                            y1={42.7}
                            x2={77.55}
                            y2={68.74}
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop offset={0.3} stopColor="#fff" />
                            <stop offset={1} />
                        </linearGradient>
                        <linearGradient
                            id="theme-gradient"
                            x1="0%"
                            y1="0%"
                            x2="100%"
                            y2="100%"
                            gradientUnits="userSpaceOnUse"
                        >
                            {localStorage.locales_theme === "red" &&
                                <>
                                    <stop offset="0%" stopColor="#ae7199" />
                                    <stop offset="50%" stopColor="#e74360" />
                                    <stop offset="100%" stopColor="#f08635" />
                                </>
                            }
                            {localStorage.locales_theme === "blue" &&
                                <>
                                    <stop offset="0%" stopColor="#01488a" />
                                    <stop offset="100%" stopColor="#002455" />
                                </>
                            }



                        </linearGradient>
                        <linearGradient id="i-trade-1" gradientTransform="rotate(90)">

                            <stop className="i-trade-1-start" offset="5%" stopOpacity={1} />
                            <stop className="i-trade-1-stop" offset="95%" stopOpacity={1} />
                        </linearGradient>
                        <linearGradient id="i-trade-2" gradientTransform="rotate(90)">
                            <stop className="i-trade-2-start" offset="5%" stopOpacity={1} />
                            <stop className="i-trade-2-stop" offset="95%" stopOpacity={1} />
                        </linearGradient>
                        <linearGradient id="i-trade-3" gradientTransform="rotate(90)">
                            <stop className="i-trade-3-start" offset="5%" stopOpacity={1} />
                            <stop className="i-trade-3-stop" offset="95%" stopOpacity={1} />
                        </linearGradient>
                        <linearGradient id="i-trade-4" gradientTransform="rotate(90)">
                            <stop className="i-trade-4-start" offset="5%" stopOpacity={1} />
                            <stop className="i-trade-4-stop" offset="95%" stopOpacity={1} />
                        </linearGradient>
                        <linearGradient id="i-trade-5" gradientTransform="rotate(90)">
                            <stop className="i-trade-5-start" offset="5%" stopOpacity={1} />
                            <stop className="i-trade-5-stop" offset="95%" stopOpacity={1} />
                        </linearGradient>

                    </defs>
                </svg>
            </div>
        )
    }
}

export default MasterSvg;